import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24b12987"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "transaction-content",
  id: "transactionContentContainer"
}
const _hoisted_2 = {
  key: 0,
  class: "px-4 pt-4"
}
const _hoisted_3 = {
  key: 0,
  class: "created-at is-flex is-align-items-center"
}
const _hoisted_4 = { class: "created-at-relative" }
const _hoisted_5 = { class: "error-title" }
const _hoisted_6 = { class: "advanced-view-trigger is-flex is-align-items-center" }
const _hoisted_7 = { class: "advanced-view-content-inner" }
const _hoisted_8 = { class: "iframe-inner is-relative" }

import { ref, computed, onMounted } from 'vue'

import Header from '@/popup/components/views/Confirmation/Header.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import TransactionData from '@/popup/components/TransactionIFrame/helpers/TransactionData.vue'
import TransactionInfo from '@/popup/components/Transaction/TransactionInfo.vue'
import AdvancedError from '@/popup/components/TransactionIFrame/helpers/AdvancedError.vue'
import TransactionRawBytes from '@/popup/components/TransactionIFrame/helpers/TransactionRawBytes.vue'
import {
  isContractDeployment,
  statusColor,
} from '@/shared/isTransactionMethods'
import TransactionIframe from '@/popup/components/Transaction/TransactionIframe.vue'
import Spinner from '@/popup/components/shared/Spinner.vue'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'
import { unwrapData } from '@/shared/unwrapData'
import { d, relativeTime, t } from '@/popup/lib/i18n'
import Notification from '@/popup/components/shared/Notification.vue'
import {
  Transaction,
  TransactionChangeMessage,
  TransactionComponent,
} from '@/shared/models/Transaction'
import TestnetLabel from '@/popup/components/shared/TestnetLabel.vue'
import { getErrorMessage } from '@/shared/validators'
import { PreferencesState } from '@/popup/store/PreferencesStore'

type Props = {
  transaction?: Transaction
  components?: TransactionComponent[]
  preferences?: PreferencesState
  isFixedHeader: boolean
  scrollPercentage: number
  profileBalance?: number
  isConfirmation?: boolean
}

type Emits = {
  (event: 'on-iframe-loaded'): void
  (event: 'header-offset', value: number): void
  (event: 'on-container-height-resize', height: number): void
  (event: 'on-transaction-change', message: TransactionChangeMessage): void
  (event: 'on-low-balance-cancel-click'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionContent',
  props: {
    transaction: {},
    components: {},
    preferences: {},
    isFixedHeader: { type: Boolean },
    scrollPercentage: {},
    profileBalance: {},
    isConfirmation: { type: Boolean }
  },
  emits: ["on-iframe-loaded", "header-offset", "on-container-height-resize", "on-transaction-change", "on-low-balance-cancel-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const web3Eth = useWeb3Eth().getWeb3Eth()
const isAdvancedViewExpanded = ref(false)
const staticHeaderRef = ref()
const fixedHeaderRef = ref()
const loading = ref(true)
const advancedViewTriggerRef = ref()
const advancedViewContentRef = ref()
const iframeContainerRef = ref()

const unwrappedData = computed(
  () => unwrapData(web3Eth, props?.transaction?.data)['data']
)

const onResize = ({ height }: { height: number }) => {
  emits('on-container-height-resize', height)
}

const onIFrameLoaded = () => {
  loading.value = false
  emits('on-iframe-loaded')
}

onMounted(() => {
  const resizeObserver = new ResizeObserver(() => {
    const headerOffset =
      staticHeaderRef.value?.offsetHeight -
      fixedHeaderRef.value?.children[0].offsetHeight
    emits('header-offset', headerOffset)
  })

  // attach the resize observer to the both headers so we can calculate offset properly
  if (staticHeaderRef.value && fixedHeaderRef.value) {
    resizeObserver.observe(staticHeaderRef.value)
    resizeObserver.observe(fixedHeaderRef.value)
  }
})

const onTransactionChange = (event: TransactionChangeMessage) => {
  emits('on-transaction-change', event)
}

const onAdvancedViewToggle = () => {
  // toggle the advanced view
  isAdvancedViewExpanded.value = !isAdvancedViewExpanded.value

  // cancels the transaction if we detect low balance
  if (
    props.transaction?.gasProvider?.type === 'controller' &&
    props.transaction?.error?.message ===
      t('transactions.error.insufficient_funds')
  ) {
    emits('on-low-balance-cancel-click')
    return
  }
  // calculate the height of the advanced view content and iframe container and emit the new height of the scrollable container
  // we need to wait for the advanced view content to expand before we can calculate the height
  setTimeout(() => {
    const advancedViewContentHeight = advancedViewContentRef.value?.offsetHeight
    const iframeContainerHeight = iframeContainerRef.value?.offsetHeight
    const advancedViewTriggerHeight = advancedViewTriggerRef.value?.offsetHeight

    onResize({
      height:
        advancedViewContentHeight +
        iframeContainerHeight +
        advancedViewTriggerHeight,
    })
  }, 50)
}

return (_ctx: any,_cache: any) => {
  return (_ctx.transaction)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "staticHeaderRef",
          ref: staticHeaderRef
        }, [
          _createVNode(Header, {
            transaction: _ctx.transaction,
            "is-fixed": false,
            "scroll-percentage": _ctx.scrollPercentage,
            "is-contract-deployment": _unref(isContractDeployment)(_ctx.transaction)
          }, {
            leftActions: _withCtx(() => [
              _renderSlot(_ctx.$slots, "leftActions")
            ]),
            rightActions: _withCtx(() => [
              _renderSlot(_ctx.$slots, "rightActions")
            ]),
            headerBottom: _withCtx(({ isFixed }) => [
              _renderSlot(_ctx.$slots, "headerBottom", { isFixed: isFixed })
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["transaction", "scroll-percentage", "is-contract-deployment"])
        ], 512 /* NEED_PATCH */),
        _createElementVNode("div", {
          ref_key: "fixedHeaderRef",
          ref: fixedHeaderRef
        }, [
          _createVNode(Header, {
            transaction: _ctx.transaction,
            "is-fixed": true,
            "scroll-percentage": _ctx.scrollPercentage,
            "is-contract-deployment": _unref(isContractDeployment)(_ctx.transaction),
            class: _normalizeClass(`fixed-header ${_ctx.isFixedHeader ? 'fixed-header-visible' : ''}`)
          }, {
            leftActions: _withCtx(() => [
              _renderSlot(_ctx.$slots, "leftActions")
            ]),
            rightActions: _withCtx(() => [
              _renderSlot(_ctx.$slots, "rightActions")
            ]),
            headerBottom: _withCtx(({ isFixed }) => [
              _renderSlot(_ctx.$slots, "headerBottom", { isFixed: isFixed })
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["transaction", "scroll-percentage", "is-contract-deployment", "class"])
        ], 512 /* NEED_PATCH */),
        (!_ctx.isConfirmation || _ctx.transaction.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.transaction.createdAt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(SvgIcon, {
                      name: "clock",
                      class: "mr-1",
                      color: "var(--neutral-20)",
                      width: "16",
                      height: "16"
                    }),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(relativeTime)(_ctx.transaction.createdAt)), 1 /* TEXT */),
                    _createTextVNode(" " + _toDisplayString(_unref(d)(_ctx.transaction.createdAt, 'long')), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.transaction.error)
                ? (_openBlock(), _createBlock(Notification, {
                    key: 1,
                    class: "mt-3",
                    type: "error"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_unref(getErrorMessage)(_ctx.transaction.error)) + " ", 1 /* TEXT */),
                        _createElementVNode("span", {
                          onClick: onAdvancedViewToggle,
                          class: "read-more"
                        }, " Read more")
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          ref_key: "advancedViewTriggerRef",
          ref: advancedViewTriggerRef,
          class: _normalizeClass(`is-flex is-align-content-center ${
        _ctx.isConfirmation || _ctx.transaction.status !== 'INITIALIZED'
          ? 'is-justify-content-space-between'
          : 'is-justify-content-end'
      } is-align-items-center is-clickable my-3 px-4`),
          onClick: onAdvancedViewToggle
        }, [
          (_ctx.isConfirmation)
            ? (_openBlock(), _createBlock(TestnetLabel, { key: 0 }))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: _normalizeClass(`tag status-tag is-small ${_unref(statusColor)(_ctx.transaction.status)}`)
              }, _toDisplayString(_ctx.$t(`activity.status.${_ctx.transaction.status?.toLowerCase()}`)), 3 /* TEXT, CLASS */)),
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t('confirmation.advanced_view')) + " ", 1 /* TEXT */),
            _createVNode(SvgIcon, {
              name: "arrow-down-sm",
              color: "var(--neutral-60)",
              class: _normalizeClass(`icon ${isAdvancedViewExpanded.value ? 'rotate-180' : ''}`)
            }, null, 8 /* PROPS */, ["class"])
          ])
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          ref_key: "advancedViewContentRef",
          ref: advancedViewContentRef,
          class: _normalizeClass(`advanced-view-content ${
        isAdvancedViewExpanded.value ? 'is-expanded' : ''
      }`)
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(AdvancedError, { transaction: _ctx.transaction }, null, 8 /* PROPS */, ["transaction"]),
            _createVNode(TransactionInfo, {
              transaction: _ctx.transaction,
              preferences: _ctx.preferences,
              "is-estimate": _ctx.isConfirmation
            }, null, 8 /* PROPS */, ["transaction", "preferences", "is-estimate"]),
            (_unref(isContractDeployment)(_ctx.transaction))
              ? (_openBlock(), _createBlock(TransactionRawBytes, {
                  key: 0,
                  data: _ctx.transaction.data
                }, null, 8 /* PROPS */, ["data"]))
              : (_ctx.components)
                ? (_openBlock(), _createBlock(TransactionData, {
                    key: 1,
                    "is-advanced-view": "",
                    class: "wrapped",
                    data: unwrappedData.value,
                    "function-signature": 
            _ctx.components[0]?.functionSignature || _ctx.components[1]?.functionSignature
          ,
                    selector: _ctx.components[0]?.selector || _ctx.components[1]?.selector
                  }, null, 8 /* PROPS */, ["data", "function-signature", "selector"]))
                : _createCommentVNode("v-if", true)
          ])
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: "iframe-container",
          ref_key: "iframeContainerRef",
          ref: iframeContainerRef
        }, [
          _createElementVNode("div", _hoisted_8, [
            (loading.value)
              ? (_openBlock(), _createBlock(Spinner, {
                  key: 0,
                  id: "iframeSpinner",
                  class: "confirmation-spinner",
                  "data-testid": "spinner"
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(TransactionIframe, {
              transaction: _ctx.transaction,
              components: _ctx.components,
              onOnLoaded: onIFrameLoaded,
              onOnTransactionChange: onTransactionChange,
              onOnResize: onResize
            }, null, 8 /* PROPS */, ["transaction", "components"])
          ])
        ], 512 /* NEED_PATCH */)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})